import { Action } from 'redux';
import { DISMISS_MESSAGE, SET_MESSAGE } from './messageActions';
import { MessageState } from './messageTypes';

export interface MessageActionsType extends Action {
  payload: MessageState;
}

const initialState: MessageState[] = [];

const getDistinctArray = (array: MessageState[]) =>
  array.filter((v, i, a) => a.findIndex(t => JSON.stringify(t) === JSON.stringify(v)) === i);

export default (state = initialState, action: MessageActionsType = {} as MessageActionsType) => {
  if (action.type === SET_MESSAGE) {
    const messageContext = action?.payload?.messageContext;
    const newState =
      action.payload.message?.closeable === false
        ? [...state, action.payload]
        : [...state.filter(m => m.message?.closeable === false || m.messageContext !== messageContext), action.payload];

    return getDistinctArray(newState);
  }

  if (action.type === DISMISS_MESSAGE) {
    const message = action?.payload?.message;
    const messageContext = action?.payload?.messageContext;
    return message
      ? state.filter(m => m.messageContext !== messageContext || JSON.stringify(m.message) !== JSON.stringify(message))
      : state.filter(m => m.messageContext !== messageContext);
  }

  return state;
};
